import React, { useEffect,useState } from 'react';
import { useLocation } from 'react-router-dom';
import ResultImg from './ResultImg';
import Random from './Random';


function Search(){
    
    const[oimgval,setoimgval]=useState([]);
    let location=useLocation();
    
    const GetData=async()=>{
        const res= await fetch(`https://www.themealdb.com/api/json/v1/1/search.php?s=${location.state}`);
        const realdata=await res.json();
        setoimgval(realdata.meals)
    }
    useEffect(()=>{
        GetData();
    })
    

    return (
        <>
        <div style={{marginTop: '24px'}}>

        <h1 style={{textAlign: 'center',
    fontSize: '42px'}}>{location.state}</h1>
            <div className='divresult'>
             
             {
                 (oimgval==null)?(<>
                 <div style={{width: "100%"}}>
                 <h1>result Not Found</h1>
                 <h2>Random Meals</h2>
                 <div className='divresultr'>
                 <Random />
                 <Random />
                 <Random />
                 </div>
                 </div>
                 </>):oimgval.map((curelem,index)=>{
            return (<ResultImg key={index} imgv={curelem.strMealThumb}
                name={curelem.strMeal} id={curelem.idMeal}
            />)
              
             })}
 
            
             </div>
        </div>
        </>
    )
}

export default Search;